import React, { useState, useEffect } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { 
  ChevronLeft, 
  ChevronRight,
  ArrowRight,
  Globe,
  BarChart3,
  Users,
  Target,
  TrendingUp,
  Award,
  MonitorPlay,
  Tv,
  LayoutGrid,
  Megaphone,
  PieChart
} from 'lucide-react';
import { Link } from 'react-router-dom';

const ServicePremiumTake = () => {
  const { scrollY } = useScroll();
  const [activeTab, setActiveTab] = useState(0);

  const services = [
    {
      icon: <MonitorPlay className="w-8 h-8" />,
      title: "Full-Screen Takeovers",
      description: "Command undivided attention with immersive, full-screen ads designed for maximum brand impact and engagement.",
    //   stat: "Learn More",
      color: "from-blue-600 to-cyan-500"
      
    },
    {
      icon: <TrendingUp className="w-8 h-8" />,
      title: "AI-Enhanced Personalization",
      description: "Leverage AI-driven insights to optimize creative elements dynamically, maximizing relevance and conversion potential. ",
     
    //   stat: "Learn More",
      color: "from-purple-600 to-pink-500"
   
    },
    {
      icon: <Tv className="w-8 h-8" />,
      title: "CTV & OTT Sponsorships",
      description: "Own premium, non-skippable ad slots on leading connected TV networks, delivering an uninterrupted brand experience.",
     
    //   stat: "Learn More",
      color: "from-orange-500 to-red-500"
     
    },
    {
        icon: <LayoutGrid className="w-8 h-8" />,
        title: " Premium Homepage & App Takeovers",
      description: "Secure exclusive, high-visibility placements on top websites and apps, ensuring brand prominence and top-of-mind recall.",
        // stat: "Learn More",
        color: "from-orange-500 to-red-500"
       
      },
      {
        icon: <Megaphone className="w-8 h-8" />,
        title: "Dynamic Rich Media & High-Impact Display",
      description: "Captivate audiences with interactive, visually compelling ad formats that enhance user experience and drive engagement.",
        // stat: "Learn More",
        color: "from-purple-600 to-pink-500"

      },
      {
        icon: <PieChart className="w-8 h-8" />,
        title: "Real-Time Brand Lift & Engagement Analytics",
        description: "Gain deep performance insights with advanced metrics to track awareness, engagement, and overall campaign effectiveness.",
        // stat: "Learn More",
        color: "from-blue-600 to-cyan-500"
      
      },
      {
        icon: <Users className="w-8 h-8" />,
        title: "Seamless Cross-Device Reach Ability",
        description: "Maintain a unified brand presence across desktop, mobile, and tablet, ensuring a consistent, high-impact experience.",
        // stat: "Learn More",
        color: "from-blue-600 to-cyan-500"
     
      },
      {
        icon: <Award className="w-8 h-8" />,
        title: "Exclusive Access to Premium Inventory   ",
        description: "Advertise within high-quality, brand-safe environments on top-tier publisher networks, amplifying reach and credibility.",
        // stat: "Learn More",
        color: "from-purple-600 to-pink-500"

      },
      {
        icon: <TrendingUp className="w-8 h-8" />,
        title: "Rapid & Precision-Optimized Campaign Execution",
        description: "Deploy high-impact campaigns with speed and strategic accuracy, maximizing efficiency and audience connection.",
        // stat: "Learn More",
        color: "from-orange-500 to-red-500"
      
      },
      
      
      
  ];

  const features = [
    { title: "Dynamic Optimization", value: "93%", subtitle: "Campaign Success Rate" },
    { title: "Global Coverage", value: "200+", subtitle: "Countries Reached" },
    { title: "Client Satisfaction", value: "98%", subtitle: "Retention Rate" },
    { title: "ROI Improvement", value: "180%", subtitle: "Average Increase" }
  ];

  const statsY = useTransform(scrollY, [0, 300], [100, 0]);
  const statsOpacity = useTransform(scrollY, [0, 300], [0, 1]);

  return (
    <div className="w-full">
      {/* Services Section */}
      <section className="py-20 px-6 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Unmatched Advantages of CTV Advertising with BidBox

            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Leverage AI-powered programmatic solutions to deliver high-impact branding across premium digital platforms. Reach the right audience, at the right time, with precision and scale.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8">
            {services.map((service, index) => (
                <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.2, delay: index * 0.1 }}
                whileHover={{ scale: 1.05 }} // Hover effect
                className="relative group"
              >
                <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:bg-gray-100">
                  <div className={`absolute inset-x-0 h-2 top-0 rounded-t-2xl bg-gradient-to-r ${service.color}`} />
                  <div className="mb-6 text-blue-600">{service.icon}</div>
                  <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
                  <p className="text-gray-600 mb-6">{service.description}</p>
                  <div className="flex items-center justify-between">
                  <Link to={service.link} className="text-lg font-semibold text-blue-600 hover:underline">
    {service.stat}
  </Link>
                  </div>
                </div>
              </motion.div>
              
            //   <motion.div
            //     key={index}
            //     initial={{ opacity: 0, y: 20 }}
            //     whileInView={{ opacity: 1, y: 0 }}
            //     viewport={{ once: true }}
            //     transition={{ duration: 0.6, delay: index * 0.2 }}
            //     className="relative group"
            //   >
            //     <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
            //       <div className={`absolute inset-x-0 h-2 top-0 rounded-t-2xl bg-gradient-to-r ${service.color}`} />
            //       <div className="mb-6 text-blue-600">{service.icon}</div>
            //       <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
            //       <p className="text-gray-600 mb-6">{service.description}</p>
            //       <div className="flex items-center justify-between">
            //         <span className="text-lg font-semibold">{service.stat}</span>
            //         <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transition-colors" />
            //       </div>
            //     </div>
            //   </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      {/* <motion.section 
        style={{ y: statsY, opacity: statsOpacity }}
        className="py-20 px-6 bg-gradient-to-r from-blue-600 to-purple-600"
      >
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="text-center text-white"
              >
                <div className="text-5xl font-bold mb-2">{feature.value}</div>
                <div className="text-xl font-semibold mb-1">{feature.title}</div>
                <div className="text-blue-200">{feature.subtitle}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section> */}
    </div>
  );
};

export default ServicePremiumTake;